import SalesFormulas from "../_helpers/formulas/sales-formulas";
class SalesOrderHeader {
  constructor() {
    this.FXTotal = 0;
    this.OrderNo = "";
    this.AgentRef = "";
    this.Confirmation = "";
    this.ShipDate = null;
    this.RequiredByDate = null;
    this.CustomerDeliveryAddressLineNo = null;
    this.Code = 0;
    this.CustomerCode = null;
    this.CompanyCode = null;
    this.BranchCode = null;
    this.DivisionCode = null;
    this.SalesOrderTypeCode = null;
    this.SalesRepresentativeCode = null;
    this.ConsignmentNo = "";
    this.UserComment1 = "";
    this.UserComment2 = "";
    this.UserComment3 = "";
    this.UserComment4 = "";
    this.UserComment5 = "";
    this.UserComment6 = "";
    this.UserComment7 = "";
    this.UserComment8 = "";
    this.UserComment9 = "";
    this.UserComment10 = "";
    this.UserComment11 = "";
    this.UserComment12 = "";
    this.UserComment13 = "";
    this.UserComment14 = "";
    this.UserComment15 = "";
    this.UserComment16 = "";
    this.UserComment17 = "";
    this.UserComment18 = "";
    this.UserComment19 = "";
    this.UserComment20 = "";
    this.ItemCount = 0;
    this.ExTaxTotal = 0;
    this.TaxTotal = 0;
    this.Total = 0;
    this.Status = "A";
    this.CurrencyCode = "";
    this.DateIn = null;
    this.RequiredByDate = null;
    this.ShipDate = null;
    this.ExchangeRate = null;
    this.DeliveryAddressCompanyName = "";
    this.DeliveryAddressStreetLine1 = "";
    this.DeliveryAddressStreetLine2 = "";
    this.DeliveryAddressSuburb = "";
    this.DeliveryAddressState = "";
    this.DeliveryAddressPostcode = "";
    this.DeliveryAddressCountry = "";

    this.SalesOrderDetails = [];
    this.SalesOrderNotes = [];
  }
}

class SalesOrderDetail {
  constructor() {
    this.UseMarket = "";
    this.ApplyFreight = "";
    this.DefaultPrice = 0;
    this.CustomerSalesContractCode = null;
    this.CustomerSalesContractLineNo = null;
    this.ProductDescription = "";
    this.AvailableQuantity = 0;
    this.Include = null;
    this.ItemCode = "";
    this.ItemType = "S";
    this.SalesUMQty = null;
    this.SalesUM = "";
    this.SalesUMNetPrice = 0;
    this.LineTotal = 0;
    this.AddDiscPriceGroupCode = 0;
    this.AddDiscPricingMethod = "";
    this.AddDiscPricingMethodValue = 0;
    this.AddDiscSalesUMPrice = 0;
    this.AddDiscStockUMPrice = 0;
    this.PriceGroupCode = 0;
    this.PriceGroupSalesUMPrice = 0;
    this.PriceGroupStockUMPrice = 0;
    this.PricingMethod = "";
    this.PricingMethodValue = 0;
    this.CalculatedDiscPcnt = 0;
    this.Comment = "";
    this.CustomerProduct = "";
    this.DiscFXLineTotal = 0;
    this.DiscLineTotal = 0;
    this.DiscPcnt = 0;
    this.ExTaxUnitCost = 0;
    this.FXLineTotal = 0;
    this.IsCommentVisible = "N";
    this.IsPrimeCostItem = "N";
    this.KitVersion = 0;
    this.LineNo = 0;
    this.NetFXLineTotal = 0;
    this.NetLineTotal = 0;
    this.RecordId = "00000000-0000-0000-0000-000000000000";
    this.RequiredByDate = new Date();
    this.SalesTaxPcnt = 0;
    this.SalesUMConversion = 0;
    this.SalesUMCost = 0;
    this.SalesUMFXPrice = 0;
    this.SalesUMIsVariable = "N";
    this.SalesUMManufacturedCost = 0;
    this.SalesUMNetFXPrice = 0;
    this.SalesUMPrice = 0;
    this.SalesUMPromotionNetPrice = 0;
    this.SalesUMStandardCost = 0;
    this.SalesUMStandardPrice = 0;
    this.ShipDate = new Date();
    this.Status = "A";
    this.StockUM = "";
    this.StockUMFXPrice = 0;
    this.StockUMManufacturedCost = 0;
    this.StockUMNetFXPrice = 0;
    this.StockUMNetPrice = 0;
    this.StockUMPrice = 0;
    this.StockUMQty = 0;
    this.StockUMStandardCost = 0;
    this.StockUMStandardPrice = 0;
    this.TaxableFXLineTotal = 0;
    this.TaxableLineTotal = 0;
    this.TaxCode = 0;
    this.TaxFXLineTotal = 0;
    this.TaxLineTotal = 0;
    this.WetFreightAdjustment = 0;
    this.WetFXFreightAdjustment = 0;
    this.WetFXLineTotal = 0;
    this.WetLineTotal = 0;
    this.WetPcnt = 0;
    this.OrderNo = "";
    this.AgentRef = "";
    this.Confirmation = "";
    this.CustomerDeliveryAddressLineNo = null;
    this.DeliveryAddressCompanyName = "";
    this.DeliveryAddressStreetLine1 = "";
    this.DeliveryAddressStreetLine2 = "";
    this.DeliveryAddressSuburb = "";
    this.DeliveryAddressState = "";
    this.DeliveryAddressPostcode = "";
    this.DeliveryAddressCountry = "";
  }

  toJSON() { }


}

SalesOrderHeader.prototype.toJSON = function () {
  var copy = Object.assign({}, this);
  delete copy.AgentRef;
  delete copy.Confirmation;
  delete copy.FXTotal;
  copy.ShipDate = copy.ShipDate.toSaveDate();
  copy.RequiredByDate = copy.RequiredByDate.toSaveDate();
  copy.CustomerDeliveryAddressLineNo = copy.CustomerDeliveryAddressLineNo.toString();
  return copy;
};

SalesOrderDetail.prototype.toJSON = function () {
  var copy = Object.assign({}, this);
  delete copy.Fields;
  delete copy.AvailableQuantity;
  delete copy.Include;
  delete copy.ProductDescription;
  delete copy.ApplyFreight;
  delete copy.UseMarket;
  delete copy.DefaultPrice;
  delete copy.Subscriptions;
  delete copy.OrderNo;
  delete copy.AgentRef;
  delete copy.Confirmation;
  delete copy.CustomerDeliveryAddressLineNo;
  delete copy.DeliveryAddressCompanyName;
  delete copy.DeliveryAddressStreetLine1;
  delete copy.DeliveryAddressStreetLine2;
  delete copy.DeliveryAddressSuburb;
  delete copy.DeliveryAddressState;
  delete copy.DeliveryAddressPostcode;
  delete copy.DeliveryAddressCountry;
  delete copy.ProductCode;

  copy.ShipDate = copy.ShipDate.toSaveDate();
  copy.RequiredByDate = copy.RequiredByDate.toSaveDate();
  copy.IsCommentVisible =
    copy.IsCommentVisible === "Y" ||
      copy.IsCommentVisible === 1 ||
      copy.IsCommentVisible === true
      ? true
      : false;
  copy.IsPrimeCostItem =
    copy.IsPrimeCostItem === "Y" ||
      copy.IsPrimeCostItem === 1 ||
      copy.IsPrimeCostItem === true
      ? true
      : false;
  copy.SalesUMIsVariable =
    copy.SalesUMIsVariable === "Y" ||
      copy.SalesUMIsVariable === 1 ||
      copy.SalesUMIsVariable === true
      ? true
      : false;
  copy.AddDiscPricingMethodValue = Number(copy.AddDiscPricingMethodValue);
  copy.PricingMethodValue = Number(copy.PricingMethodValue);
  return copy;
};

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  // calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  // calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  // calculateSalesUMPriceFromSalesUMFXPrice,
  // calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = SalesFormulas;

const SalesOrderState = {

  setStockPrices(record) {
    record.StockUMQty = calculateStockUMQty(
      record.SalesUMQty,
      record.SalesUMConversion
    );

    // Stock
    record.StockUMFXPrice = calculateStockUMFXPrice(
      record.SalesUMFXPrice,
      record.SalesUMConversion
    );

    record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
      record.SalesUMNetFXPrice,
      record.SalesUMConversion
    );

    record.StockUMPrice = calculateStockUMPrice(
      record.SalesUMPrice,
      record.SalesUMConversion
    );

    record.StockUMNetPrice = calculateStockUMNetPrice(
      record.SalesUMNetPrice,
      record.SalesUMConversion
    );

    return record;
  },
  setLineTotals(record, model) {
    // FX Totals
    record.DiscFXLineTotal = calculateDiscFXLineTotal(
      record.SalesUMFXPrice,
      record.SalesUMNetFXPrice,
      record.SalesUMQty
    );
    record.NetFXLineTotal = calculateNetFXLineTotal(
      record.SalesUMNetFXPrice,
      record.SalesUMQty
    );
    record.WetFXLineTotal = calculateWetFXLineTotal(
      record.NetFXLineTotal,
      record.WetPcnt
    );

    record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
      record.NetFXLineTotal,
      record.WetFXLineTotal
    );
    record.TaxFXLineTotal = calculateTaxFXLineTotal(
      record.NetFXLineTotal,
      record.WetFXLineTotal,
      record.SalesTaxPcnt
    );
    record.FXLineTotal = calculateFXLineTotal(
      record.TaxableFXLineTotal,
      record.TaxFXLineTotal
    );

    // Totals
    record.DiscLineTotal = calculateDiscLineTotal(
      record.DiscFXLineTotal,
      model.ExchangeRate
    );
    record.NetLineTotal = calculateNetLineTotal(
      record.NetFXLineTotal,
      model.ExchangeRate
    );
    record.WetLineTotal = calculateWetLineTotal(
      record.WetFXLineTotal,
      model.ExchangeRate
    );
    record.TaxableLineTotal = calculateTaxableLineTotal(
      record.TaxableFXLineTotal,
      model.ExchangeRate
    );
    record.TaxLineTotal = calculateTaxLineTotal(
      record.TaxFXLineTotal,
      model.ExchangeRate
    );
    record.LineTotal = calculateLineTotal(
      record.FXLineTotal,
      model.ExchangeRate
    );
    // window.ViewModel.calculateComputedFields();

    return record;
  }
};

export { SalesOrderHeader, SalesOrderDetail, SalesOrderState };
